<template>
    <div>
        <div class="d-flex align-center justify-space-between mb-3">
            <h1><v-icon color="primary" large>mdi-account-box</v-icon> Usuarios del Sistema</h1>
        </div>

        <v-data-table
            :loading="cargando"
            :headers="encabezadoTabla"
            :items="usuarios"
            sort-by="rol"
            class="elevation-3 rounded-xl"
            :footer-props="{ itemsPerPageText: 'Por página' }"
        >
            <!-- Badge de rol con color -->
            <template v-slot:[`item.rol`]="{ item }">
                <v-chip small :color="colorRol(item.rol)" dark>
                    <v-icon x-small left>{{ iconoRol(item.rol) }}</v-icon>
                    {{ etiquetaRol(item.rol) }}
                </v-chip>
            </template>

            <!-- Opciones -->
            <template v-slot:[`item.opciones`]="{ item }">
                <v-btn icon color="primary" @click="editar(item.id)" title="Editar usuario">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="eliminar(item)" title="Eliminar usuario"
                    :disabled="item.id === miId">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- FAB nuevo usuario -->
        <v-btn fab dark x-large elevation="8" color="primary" fixed right bottom to="/nuevo-usuario">
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>

        <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
            <dialogo-eliminar
                :nombre="itemSeleccionado"
                @cancelar="cerrarDialogoEliminar"
                @eliminar="confirmarEliminar"
            />
        </v-dialog>

        <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top>
            {{ mensaje.texto }}
        </v-snackbar>

        <v-overlay :value="cargando">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>
    </div>
</template>

<script>
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'
import HttpService from '../../Servicios/HttpService'

const ROLES = {
    admin:         { label: 'Administrador', color: 'amber darken-2',  icon: 'mdi-shield-crown' },
    entrenador:    { label: 'Entrenador',    color: 'blue darken-1',   icon: 'mdi-dumbbell' },
    recepcionista: { label: 'Recepcionista', color: 'teal darken-1',   icon: 'mdi-desk' },
}

export default {
    name: 'Usuarios',
    components: { DialogoEliminar },

    data: () => ({
        cargando: false,
        mostrarDialogoEliminar: false,
        usuario: {},
        usuarios: [],
        encabezadoTabla: [
            { text: 'Usuario',    sortable: true,  value: 'usuario' },
            { text: 'Nombre',     sortable: true,  value: 'nombre' },
            { text: 'Teléfono',   sortable: false, value: 'telefono' },
            { text: 'Rol',        sortable: true,  value: 'rol' },
            { text: 'Opciones',   sortable: false, value: 'opciones' },
        ],
        itemSeleccionado: '',
        mensaje: { texto: '', color: '' },
        mostrarMensaje: false,
        miId: parseInt(localStorage.getItem('idUsuario')) || 0,
    }),

    mounted() {
        this.obtenerUsuarios()
    },

    methods: {
        colorRol(rol)    { return (ROLES[rol] || ROLES.recepcionista).color },
        iconoRol(rol)    { return (ROLES[rol] || ROLES.recepcionista).icon },
        etiquetaRol(rol) { return (ROLES[rol] || ROLES.recepcionista).label },

        editar(idUsuario) {
            this.$router.push({ name: 'EditarUsuario', params: { id: idUsuario } })
        },

        eliminar(usuario) {
            this.itemSeleccionado = usuario.nombre
            this.usuario = usuario
            this.mostrarDialogoEliminar = true
        },

        cerrarDialogoEliminar() {
            this.mostrarDialogoEliminar = false
            this.usuario = {}
        },

        confirmarEliminar() {
            this.cargando = true
            HttpService.eliminar('usuarios.php', { metodo: 'delete', id: this.usuario.id })
            .then(eliminado => {
                if (eliminado) {
                    this.mostrarDialogoEliminar = false
                    this.mensaje = { texto: 'Usuario eliminado', color: 'success' }
                    this.mostrarMensaje = true
                    this.cargando = false
                    this.obtenerUsuarios()
                }
            })
        },

        obtenerUsuarios() {
            this.cargando = true
            HttpService.obtenerConDatos({ metodo: 'get' }, 'usuarios.php')
            .then(respuesta => {
                this.usuarios = respuesta || []
                this.cargando = false
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Usuarios/Usuarios.vue